import { getDomainConfig } from '@/config/domains/domainConfig'

export const getConfigurationFromUrl = (url: string) => {
  const domainConfig = getDomainConfig()

  const urlObj = new URL(url)
  const hostname: string = urlObj.hostname
  const pathname: string = urlObj.pathname

  if (hostname === 'localhost' || hostname === '[::1]') {
    return domainConfig['www.bistroo.nl'].configurations[0]
  }

  if (!Object.keys(domainConfig).includes(hostname)) {
    throw new Error(`${hostname} is not a valid domain`)
  }

  const activeConfig = domainConfig[hostname]

  // Sort configurations by basePath length in descending order
  const sortedConfigurations = activeConfig.configurations.sort(
    (a, b) => b.basePath.length - a.basePath.length,
  )

  for (const config of sortedConfigurations) {
    if (pathname === config.basePath || pathname.startsWith(`${config.basePath}/`)) {
      return config
    }
  }

  throw new Error(`No valid configuration found for ${pathname}`)
}